// extracted by mini-css-extract-plugin
export default {"InfoTooltip":"InfoTooltip_InfoTooltip__lVjD5"};